import { useEffect, useState } from 'react';
import { useFont } from '../../../ContextFont';
import Advogado from'../../../acets/adv.jpg'
import Element01 from '../../../acets/elements/1.png'
import Efct28 from '../../../acets/efectsfilters/28.png'
import IcoEdit from'../../../acets/icon/edit.svg'

export default function Lay39(props){
  const { fonte, alterarFonte, imagens, adicionarImagem, handleDownloadImage } = useFont();
  const [titulo, setTitulo]=useState('Somente nesta segunda-feira promoção, desconto de 60%')
  const [subtitulo,setSubtitulo]=useState('sem')
  const [modalData, setModaldata]=useState(false)
  const [numimg,setNumimg]=useState(8)

  useEffect(() => {
    // Atualiza os estados locais quando props.datal é alterado
  
  }, []); 
  return(
      <div className='w33 cell-tamanho90 center celular  b2 cont-circ7 bordaElements ma10b0'>
       <div className='p10 b2 w10 cont-circ50pc fb'>39</div>
      <div id="resultImg39" className="w100 h40 column between cell-tamanho b2 bordaElements "style={{ background:props.trapColor  }}  >
        <div className='w100 h40 column center cell-tamanho' style={{ backgroundImage: `url('${Efct28}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat',backgroundPosition:'center'}}>
        <div className=" h40 w100 column center cell-tamanho" >
        <div className="h40 w100 column center cell-tamanho"  >
            <div className='w80 h20 column end center  ma10b0 ' >
                <label className='c3 fb  cen p10' style={{fontSize:`${props.titlesize*0.7}px`,color:props.textColor}}>
                  {titulo}  
                </label>
            </div>
          </div>
        </div>
        { modalData&&
            <div className='posiabste b2 h30 z16 w17 p10 cell-tamanho-metade55 bordaElements'>
              <div className='w100 row between'>
                 <label className=''>Titulo</label>
                <img src='https://cdn-icons-png.flaticon.com/128/70/70287.png' className='pp w10' onClick={() => setModaldata(!modalData)}/>
              </div>
              <input type='text' value={titulo} onChange={(e)=>setTitulo(e.target.value)}/>
            </div>
            }
      </div>
      </div>
      <div className="w100 he20 overflowY">
          <div className="w100 row between ma5">
            <div className="row w50">
            <img src='https://cdn-icons-png.flaticon.com/128/535/535285.png' className='w15 ml5' alt='plus / mais'/>
            <img src='https://cdn-icons-png.flaticon.com/128/5948/5948565.png' className='w15 ml5' alt='plus / mais'/>
            <img src='https://cdn-icons-png.flaticon.com/128/5728/5728145.png' className='w15 ml5' alt='plus / mais'/>
            </div>
            <div className="w50 row between">
              
            </div>
          </div>
          <label className="fs08em">{props.datal.legenda}</label>
          <div>
            <label className="w100 fs08em fw500">{props.datal.hashtag}</label>
          </div>
        </div>
      <div className='w100 row between'> 
        <div className='h5 w30 fs08em cont-circ8 pp b2 row center  m10' 
            onClick={() => setNumimg(numimg >= 9 ? 0 : numimg + 1)}>
              Imagem
              <img src='https://cdn-icons-png.flaticon.com/128/1829/1829415.png' alt='IcoEdit' className='w17 m10'/>
            </div>
        <div 
            className='w30 h5 fs08em cont-circ8 pp b2 row center  m10'
            onClick={() => setModaldata(!modalData)}>
            {modalData ? "Fech." : "Texto"}
            <img src={IcoEdit} alt='IcoEdit' className='w25'/>
        </div>
        <div 
          className="w30 h5 fs08em cont-circ8 pp b2 row center  m10" 
          onClick={() => handleDownloadImage('resultImg39')}>
            Baixar
          <img src='https://cdn-icons-png.flaticon.com/128/5191/5191992.png' alt='IcoEdit' className='w17 m10'/>
        </div>
      </div> 
      </div>
    )
}